/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsageBotCallsDto } from '../../models/usage-bot-calls-dto';

export interface GetUsageBots$Params {
  from?: string;
  to?: string;
  'X-API-Version'?: string;
}

export function getUsageBots(http: HttpClient, rootUrl: string, params?: GetUsageBots$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageBotCallsDto>> {
  const rb = new RequestBuilder(rootUrl, getUsageBots.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsageBotCallsDto>;
    })
  );
}

getUsageBots.PATH = '/api/usage-statistics/bots';
